export const HOME_ROUTE = '/';

export const SELECT_PRODUCT_MOBILE = '/seleccionar-producto';
export const MOTIVE_MESSAGE_MOBILE = '/mensaje-motivo';

export const TICKET_SUCCESSFUL = '/solicitud-creada-exitosamente';
export const TICKET_SUCCESSFUL_INNER_FORMS = '/gracias';
export const TICKET_ERROR = '/solicitud-error';

export const NOT_RECEIVED_PRODUCT = '/producto-no-recibido';
export const NOT_RECEIVED_PRODUCT_MOBILE = '/mobile-producto-no-recibido';
export const AUTHORIZE_THIRD = '/autorizar-tercero';
export const AUTHORIZE_THIRD_MOBILE = '/mobile-autorizar-tercero';
export const CHANGE_ADDRESS = '/cambiar-direccion';
export const CHANGE_ADDRESS_MOBILE = '/mobile-cambiar-direccion';
export const CHANGE_DATE = '/cambiar-fecha';
export const CHANGE_DATE_MOBILE = '/mobile-cambiar-fecha';
export const GOLD_DISPATCH_CHARGE = '/cobro-despacho-gold-silver';
export const GOLD_DISPATCH_CHARGE_MOBILE = '/mobile-cobro-despacho-gold-silver';

export const BAD_STATE_PRODUCT = '/producto-mal-estado';
export const INCOMPLETE_PRODUCT = '/producto-incompleto';
export const OTHER_PRODUCT = '/llego-otro-producto';
export const NOT_WORKING_PRODUCT = '/producto-no-funciona';
export const CHANGE_PRODUCT = '/cambiar-producto';
export const CHANGE_PRODUCT_MOBILE = '/mobile-cambiar-producto';
export const PRODUCT_WITH_ALARM = '/producto-con-alarma';

export const CANCEL_PURCHASE = '/anular-compra';
export const STATUS_CANCEL_PURCHASE = '/estado-compra-anulada';
export const REVERSE_OUT_OF_TIME = '/reversa-fuera-de-plazo';

export const ASSEMBLE_PRODUCT = '/armar-producto';

export const CHANGE_PASS_RIPLEY_COM = '/cambio-contrasena';
export const CHANGE_PASS_RIPLEY_COM_MOBILE = '/mobile-cambio-contrasena';
export const CHANGE_EMAIL = '/cambiar-email';
export const CHANGE_EMAIL_MOBILE = '/mobile-cambiar-email';
export const INVOICE_COPY = '/copia-boleta-factura';
export const PROBLEM_IN_PURCHASE = '/inconveniente-al-comprar';
export const PAGE_ERROR = '/error-en-la-pagina';
export const REMOVE_CLIENT_DATA = '/eliminar-datos-cliente';

export const GET_GIFTCARD_BALANCE = '/consultar-saldo-giftcard';
export const EXTEND_VALIDITY = '/extender-vigencia-giftcard';
export const PROBLEMS_GIFTCARD = '/inconveniente-giftcard';
export const PROBLEMS_GIFTCARD_MOBILE = '/mobile-inconveniente-giftcard';

export const ARCO_LAW_INFO = '/derechos-arco';

export const RPHONE = '/rphone';
export const DEBIT = '/debito';
export const PROVIDERS = '/proveedores';
export const STORE = '/tienda';
export const TICKETS_CREATE = 'tickets/create';
export const DEBIT_PAYMENT = 'debitPayment';
